import { FactoryArg } from 'imask'
import { ExtendFactoryArgOptions } from 'imask/esm/masked/factory'
import { RegisterOptions } from 'react-hook-form'
import { IMask } from 'react-imask'

export default interface DataFormatPattern<
  T extends ExtendFactoryArgOptions<{ expose?: boolean | undefined }>
> {
  mask: T
  prepareChar?: (char: string) => string
  hiddenMask?: string
  blocks: {
    [key: string]: FactoryArg
  }
  placeholder?: string
  rules?: RegisterOptions
  validate?: (value?: string) => boolean | string
  isValid?: (value?: string) => boolean
  hide?: (value: string) => string
  isAtLeast16YearsOld?: (value?: string) => boolean | string
  isFutureDate?: (value?: string) => boolean
}

export const applyHiddenMask = (value: string, hiddenMask: string): string => {
  const masked = IMask.createMask({
    mask: hiddenMask
  })
  masked.resolve(value)
  return masked.value
}
